import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { Bell } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export default function NotificationBell() {
  const nav = useNavigate();
  const { user } = useAuth();
  const minor = user?.is_minor || user?.profile === "child" || user?.profile === "teen";
  const [open, setOpen] = useState(false);
  const [items, setItems] = useState([]);
  const [unread, setUnread] = useState(0);
  const ref = useRef(null);

  const load = async () => {
    try { const { data } = await api.get("/community-space/notifications"); setItems(data.notifications || []); setUnread(data.unread || 0); }
    catch { /* silencieux */ }
  };

  useEffect(() => {
    if (minor) return;
    load(); const id = setInterval(load, 60000); return () => clearInterval(id);
  }, [minor]);
  useEffect(() => {
    const h = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", h); return () => document.removeEventListener("mousedown", h);
  }, []);

  // Les mineurs n'ont pas de notifications sociales (fonctions sociales désactivées).
  if (minor) return null;


  const toggle = async () => {
    const willOpen = !open; setOpen(willOpen);
    if (willOpen && unread > 0) { try { await api.post("/community-space/notifications/read"); setUnread(0); } catch {} }
  };

  return (
    <div className="relative" ref={ref}>
      <button onClick={toggle} data-testid="notif-bell" className="relative w-9 h-9 rounded-full flex items-center justify-center text-white/70 hover:text-gold hover:bg-white/[0.05] transition-colors">
        <Bell size={18} />
        {unread > 0 && <span data-testid="notif-badge" className="absolute -top-0.5 -right-0.5 min-w-[16px] h-4 px-1 rounded-full bg-gold text-black text-[10px] font-bold flex items-center justify-center">{unread > 9 ? "9+" : unread}</span>}
      </button>
      {open && (
        <div data-testid="notif-panel" className="absolute right-0 mt-2 w-80 max-h-96 overflow-y-auto rounded-2xl border border-gold/25 p-2 z-[800] shadow-2xl" style={{ background: "#0A0A0A" }}>
          <p className="text-white/40 text-[11px] uppercase tracking-widest px-2 py-1">Notifications</p>
          {items.length === 0 && <p className="text-white/30 text-sm px-2 py-6 text-center">Aucune notification.</p>}
          {items.map((n) => (
            <button key={n.notif_id} onClick={() => { setOpen(false); if (n.link) nav(n.link); }}
              className={`w-full text-left rounded-lg px-2.5 py-2 hover:bg-white/[0.05] ${n.read ? "opacity-60" : ""}`}>
              <p className="text-sm text-white/85">{n.title}</p>
              {n.body && <p className="text-xs text-white/50 line-clamp-1">{n.body}</p>}
              <p className="text-[10px] text-white/30 mt-0.5">{new Date(n.created_at).toLocaleString("fr-FR")}</p>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
